import React from "react";
import { SHOWCASES, MOTIVATION_LABELS } from "./onboardingContent";

/**
 * OnboardingShowcase — feature cards tailored to the visitor's motivation.
 * Stacked cards + one Continue button: scrolling beats swiping at 375px.
 */
export default function OnboardingShowcase({ motivation, onContinue }) {
  const cards = SHOWCASES[motivation] || SHOWCASES.quran;
  const goal = MOTIVATION_LABELS[motivation] || MOTIVATION_LABELS.quran;

  return (
    <div className="w-full">
      <h2 className="text-xl sm:text-2xl font-semibold text-dt-parchment mb-1.5">
        Built for {goal}
      </h2>
      <p className="text-sm text-dt-parchment-dim mb-5">
        Here's how Murājaʿa gets you there.
      </p>
      <div className="flex flex-col gap-3 mb-6">
        {cards.map((card) => (
          <div key={card.title} className="surface rounded-xl px-4 py-4 animate-rise">
            <div className="flex items-start gap-3">
              <span className="text-xl select-none leading-none mt-0.5">{card.icon}</span>
              <div>
                <h3 className="text-[15px] font-semibold text-dt-parchment leading-snug">
                  {card.title}
                </h3>
                <p className="text-sm text-dt-parchment-dim mt-1">{card.body}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={onContinue}
        className="w-full px-4 py-3 rounded-xl bg-dt-gold text-dt-ink hover:brightness-105 text-sm font-semibold transition-[filter]"
      >
        See it in action
      </button>
    </div>
  );
}
